import React from "react"
import { Input, Select, Form } from "antd"
import { translations } from "../../../utils/Translation/staticTranslation"
import "../Campaigns.css"

const { Option } = Select
const { TextArea } = Input

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const isValidEmailSender = (value) => {
  const trimmed = String(value || "").trim()
  if (!trimmed) return true
  return EMAIL_REGEX.test(trimmed)
}

const DetailsStep = ({ formData, setFormData, viewMode = false }) => {
  const lang = localStorage.getItem("language") || "ar"
  const t = translations[lang]?.campaignsPage

  const handleChange = (field, value) => {
    if (viewMode) return
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }))
  }

  const emailSender = formData.emailSender || ""
  const emailSenderInvalid =
    Boolean(emailSender.trim()) && !isValidEmailSender(emailSender)

  return (
    <div>
      <Form layout="vertical">
        <Form.Item label={t?.details?.title || "Title"} required>
          <Input
            placeholder={t?.details?.title_placeholder || "New Products - January"}
            value={formData.title}
            onChange={(e) => handleChange("title", e.target.value)}
            className="details-step-input"
            disabled={viewMode}
            readOnly={viewMode}
          />
        </Form.Item>

        <Form.Item label={t?.details?.description || "Description"}>
          <TextArea
            placeholder={t?.details?.description_placeholder || "Describe your campaign..."}
            value={formData.description}
            onChange={(e) => handleChange("description", e.target.value)}
            rows={4}
            className="details-step-textarea"
            disabled={viewMode}
            readOnly={viewMode}
          />
        </Form.Item>

        <Form.Item
          label={t?.details?.email_sender || "Sender's Email"}
          validateStatus={emailSenderInvalid ? "error" : undefined}
          help={
            emailSenderInvalid
              ? t?.details?.email_sender_invalid || "Please enter a valid email address"
              : undefined
          }
        >
          <Input
            type="email"
            placeholder={
              t?.details?.email_sender_placeholder || "sender@example.com"
            }
            value={emailSender}
            onChange={(e) => handleChange("emailSender", e.target.value)}
            className="details-step-input"
            disabled={viewMode}
            readOnly={viewMode}
            autoComplete="off"
          />
        </Form.Item>

        <Form.Item label={t?.details?.campaign_type || "Campaign Type"} required>
          <Select
            value={formData.campaignType}
            onChange={(value) => handleChange("campaignType", value)}
            placeholder={t?.details?.campaign_type_placeholder || "Select campaign type"}
            className="campaign-filter-select details-step-select"
            disabled={viewMode}
          >
            <Option value="Promotional">{t?.details?.types?.promotional || "Promotional"}</Option>
            <Option value="Seasonal">{t?.details?.types?.seasonal || "Seasonal"}</Option>
            <Option value="Welcome">{t?.details?.types?.welcome || "Welcome"}</Option>
            <Option value="Updates">{t?.details?.types?.updates || "Platform Updates"}</Option>
          </Select>
        </Form.Item>
      </Form>
    </div>
  )
}

export default DetailsStep
